import SuivieAuthentComponent from './components/suivie-authent/suivie-authent.component';
import SuivieResultatComponent from './components/suivie-resultat/suivie-resultat.component';

import routerConfig from './routes';

require('./suivie-dossier.scss');

const moduleName = 'dmattnt-suivie-dossier';
angular.module(moduleName, ['ui.router'])
  .component('dmattntSuivieAuthent', new SuivieAuthentComponent())
  .component('dmattntSuivieResultat', new SuivieResultatComponent())
  .config(routerConfig);

export default {
  moduleName
};



// WEBPACK FOOTER //
// ./src/modules/suivie-dossier/suivie-dossier.module.js